__turbopack_context__.v({
  "breadcrumbs": "style-module-scss-module__QEzoda__breadcrumbs",
  "content": "style-module-scss-module__QEzoda__content",
  "contentText": "style-module-scss-module__QEzoda__contentText",
  "contentTitle": "style-module-scss-module__QEzoda__contentTitle",
  "contentWrapper": "style-module-scss-module__QEzoda__contentWrapper",
  "heading": "style-module-scss-module__QEzoda__heading",
  "sidebar": "style-module-scss-module__QEzoda__sidebar",
  "sidebarWrapper": "style-module-scss-module__QEzoda__sidebarWrapper",
  "subtitle": "style-module-scss-module__QEzoda__subtitle",
  "title": "style-module-scss-module__QEzoda__title",
  "wrapper": "style-module-scss-module__QEzoda__wrapper",
  "wrapperSection": "style-module-scss-module__QEzoda__wrapperSection",
});
